import { Modal } from 'react-bootstrap';
import { styled } from 'styled-components';

export const MainModalStyles = styled(Modal)`
  .error__announce {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #dc3545;
  }
  .custom__input {
    &.invalid {
      border-color: #dc3545;
      padding-right: calc(1.5em + 0.75rem);
      background-repeat: no-repeat;
      background-position: right calc(0.375em + 0.1875rem) center;
      background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
  }
  input {
    &.is-invalid {
      background-image: url('');
    }
  }
  .loading__container {
    transition: all ease 250ms;
    height: 100%;
    width: 100%;
    position: fixed;
    inset: 0;
    justify-content: center;
    align-items: center;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.25);
    &.hide {
      display: none;
    }
  }
  .react-datepicker-wrapper {
    width: 100%;
  }

  .modal-content {
    border-radius: 0px;
    .submit__button__container {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      > .submit__button {
        width: 100%;
        border: none;
        background-color: #006b67;
        color: white;
        padding: 8px 0;
        font-weight: 500;
        cursor: pointer;
        transition: all ease 250ms;
        &:hover {
          background-color: rgba(0, 107, 103, 0.8);
        }
        > span > i {
          border-radius: 50%;
          width: 4px;
          height: 4px;
          min-width: 4px;
          min-height: 4px;
          background-color: white;
          margin: 0 5px;
          display: inline-block;
          animation: jump 1.5s infinite;
          &:nth-child(1) {
            animation-delay: 0s;
          }
          &:nth-child(2) {
            animation-delay: 0.2s;
          }
          &:nth-child(3) {
            animation-delay: 0.4s;
          }
          @keyframes jump {
            0%,
            30%,
            100% {
              transform: translateY(0);
            }
            /* 40% {
              transform: translateY(-15px);
            } */
            50% {
              transform: translateY(-10px);
            }
          }
        }
      }
    }
  }
`;
